import React from 'react'

import icons from './Icons'

const Icon = ({ className, style, alias, color = '$PrimaryBlue', width = 64, height, viewBox, stroke, strokeWidth, onClick }) => {
	height = height || width;

	if (!alias || !icons[alias]) {
		console.warn(`Icon not found: ${alias}`);
		return null;
	}
	const resolveCssColor = (c) =>
		typeof c === 'string' &&
		!c.startsWith('$') &&
		(c.startsWith('#') || c.startsWith('rgb') || c === 'currentColor' || c === 'white' || c === 'black');
	const styleWithColor = resolveCssColor(color)
		? { color, ...style }
		: style;
	return (
		<svg className={className} style={styleWithColor} fill={color} stroke={stroke} strokeWidth={strokeWidth} width={width} height={height} viewBox={viewBox || icons[alias].viewBox} {...icons[alias].props || {}} onClick={onClick}>
			{icons[alias]['rect'] !== undefined &&
				(Array.isArray(icons[alias]['rect']) ?
					icons[alias]['rect'].map((rect, index) => (
						<rect key={index}
							x={rect.x}
							y={rect.y}
							width={rect.width}
							height={rect.height}
							rx={rect.rx}
							fill={rect.fill}
							stroke={rect.stroke}
							transform={rect.transform}
							strokeWidth={rect['stroke-width']}
						/>
					))
					:
					<rect
						x={icons[alias]['rect'].x}
						y={icons[alias]['rect'].y}
						width={icons[alias]['rect'].width}
						height={icons[alias]['rect'].height}
						rx={icons[alias]['rect'].rx}
						fill={icons[alias]['rect'].fill}
						stroke={icons[alias]['rect'].stroke}
						transform={icons[alias]['rect'].transform}
						strokeWidth={icons[alias]['rect']['stroke-width'] ?? icons[alias]['rect'].strokeWidth}
					/>)
			}
			{icons[alias].defs?.linearGradient && (
				<defs>
					<linearGradient
						id={icons[alias].defs.linearGradient.id}
						x1={icons[alias].defs.linearGradient.x1}
						y1={icons[alias].defs.linearGradient.y1}
						x2={icons[alias].defs.linearGradient.x2}
						y2={icons[alias].defs.linearGradient.y2}
						gradientUnits={icons[alias].defs.linearGradient.gradientUnits}
					>
						{icons[alias].defs.linearGradient.stops.map((stop, i) => (
							<stop key={i} offset={stop.offset} stopColor={stop.stopColor} />
						))}
					</linearGradient>
				</defs>
			)}
			{icons[alias]['g'] !== undefined ? (
				<g transform={`${typeof icons[alias]['g'] != 'object' ? `scale(${icons[alias]['g']})` : null}`} clipPath={typeof icons[alias]['g'] === 'object' ? icons[alias]['g'].clipPath : undefined}>
					{icons[alias]['paths'] && icons[alias]['paths'].map((path, i) => <path key={i} d={path} />)}
					{icons[alias]['g'].rect && (Array.isArray(icons[alias]['g'].rect) ?
						icons[alias]['g']['rect'].map((rect, index) => (
							<rect key={index}
								x={rect.x}
								y={rect.y}
								width={rect.width}
								height={rect.height}
								rx={rect.rx}
								fill={rect.fill}
								stroke={rect.stroke}
								transform={rect.transform}
								strokeWidth={rect['stroke-width']}
							/>
						))
						:
						<rect
							x={icons[alias]['g']['rect'].x}
							y={icons[alias]['g']['rect'].y}
							width={icons[alias]['g']['rect'].width}
							height={icons[alias]['g']['rect'].height}
							rx={icons[alias]['g']['rect'].rx}
							fill={icons[alias]['g']['rect'].fill} />)}
				</g>
			)
				:
				icons[alias].paths && icons[alias].paths.length > 0 ?
					Array.isArray(icons[alias].paths) && icons[alias].paths.some(p => typeof p === 'object') ?
						icons[alias].paths.map((props, i) => <path key={i} {...props} />)
						:
						icons[alias].paths.map((path, i) => <path key={i} d={path} />)
					:
					typeof icons[alias] === 'string' && <path d={icons[alias]} />
			}
		</svg>
	)
}

Icon.displayName = 'Icon'

export default Icon
